import ProgramHub from "@/components/ProgramHub";
import { PROGRAMS } from "@/lib/programs";

export default function MillionDollarMindset() {
  return <ProgramHub program={PROGRAMS["million-dollar-mindset"]} />;
}
